import { render, staticRenderFns } from "./MobileFullPageAppLayout.vue?vue&type=template&id=08385192&"
import script from "./MobileFullPageAppLayout.vue?vue&type=script&lang=js&"
export * from "./MobileFullPageAppLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports